import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation/Navigation';
import LimitedModeBanner from '../components/Subscription/LimitedModeBanner';
import { AuthClientTypes } from '../context/auth/auth.interfaces';

interface Props {
  role: AuthClientTypes['user_type'];
}

const Layout = ({ role }: Props) => {
  return (
    <main className='h-full sm:h-screen w-full flex flex-col'>
      <Header type='admin' />
      {/* Renders nothing unless the account is unactivated, so the notice and
          its Confirm Payment button follow the user across every screen. It
          belongs to the shell rather than the page so it spans the full width
          under the header, across the sidebar as well as the content. */}
      <LimitedModeBanner />
      {/* The row below the banner takes whatever height is left over. It used
          to hardcode `h-[calc(100%-106px)]`, which assumed the header was the
          only thing above it and left no room for the banner; `min-h-0` lets
          flex do the subtraction instead, for any chrome, at any header size. */}
      <section className='flex flex-1 sm:min-h-0 bg-mainBg'>
        <Navigation role={role} />
        <Outlet />
      </section>
    </main>
  );
};

export default Layout;
